import { ALL_INDIVIDUAL_PLANS, PLAN_REF_ID_MAPPING } from "@/data/plans";
import { TProductRefId } from "@/types/plan";
import { TCartItem, TPlan } from "../types.checkout";

/**
 * Check if the bundle plan is present in the cart
 */
export function isBundleInCart(cartItems: TCartItem[] | undefined): boolean {
  if (!cartItems || cartItems.length === 0) return false;
  return cartItems.some((item) => item.id === PLAN_REF_ID_MAPPING.all);
}

/**
 * Check if all individual plans are present in the cart
 */
export function hasAllIndividualPlans(cartItems: TCartItem[]): boolean {
  return ALL_INDIVIDUAL_PLANS.every((planId) =>
    cartItems.some((item) => item.id === planId),
  );
}

/**
 * Filters initial cart items to exclude plans the user already owns.
 * Removes directly owned plans and individual plans covered by an owned bundle.
 * Also strips individual plans when the bundle is present in the initial items.
 */
export function filterInitialCartItems(
  items: TCartItem[],
  ownedPlanList: TPlan[],
): TCartItem[] {
  const ownedPlanIds = new Set(ownedPlanList.map((p) => p.productRefId));
  const ownsBundle = ownedPlanIds.has(PLAN_REF_ID_MAPPING.all);

  let filtered = items.filter((item) => {
    if (ownedPlanIds.has(item.id as TProductRefId)) return false;
    if (
      ownsBundle &&
      (ALL_INDIVIDUAL_PLANS as readonly TProductRefId[]).includes(
        item.id as TProductRefId,
      )
    )
      return false;
    return true;
  });

  if (filtered.some((item) => item.id === PLAN_REF_ID_MAPPING.all)) {
    filtered = filtered.filter(
      (item) =>
        !(ALL_INDIVIDUAL_PLANS as readonly TProductRefId[]).includes(
          item.id as TProductRefId,
        ),
    );
  }

  return filtered;
}
